import { useTrademarkStore } from './mark';
import { useApplicationStore } from './application';
import { useCartStore } from './cart';
import { useOwnerStore, type OwnerStore } from './owner';
import { useTermOfUseStore, type TermOfUseStore } from './terms-of-use';
import { useProductStore, type ProductStore } from './good';
import { useContactStore, type ContactStore } from './contact';
import { useCartReferenceStore } from './cart-reference';

export function resetAllStores() {
    // Reset each store
    const trademarkStore = useTrademarkStore();
    const applicationStore = useApplicationStore();
    const cartStore = useCartStore();
    const ownerStore = useOwnerStore();
    const termOfUseStore = useTermOfUseStore();
    const productStore = useProductStore();
    const contactStore = useContactStore();
    const cartReferenceStore = useCartReferenceStore();

    // Reset each store's state using their custom reset methods
    trademarkStore.resetData();
    cartStore.resetData();
    ownerStore.resetData();
    termOfUseStore.resetData();
    productStore.resetData();
    contactStore.resetData();
    applicationStore.resetData();
    cartReferenceStore.resetData();
}

export function useImportData() {
    const productStore = useProductStore();
    const ownerStore = useOwnerStore();
    const contactStore = useContactStore();
    const termOfUseStore = useTermOfUseStore();

    const importDataAllStores = (savedData: {
        product?: ProductStore;
        owner?: OwnerStore;
        contact?: ContactStore;
        termOfUse?: TermOfUseStore;
    }) => {
        
        // Load goods data
        if (savedData.product) {
            productStore.importData(savedData.product);
        }
    
        // Load owner data
        if (savedData.owner) {
            ownerStore.importData(savedData.owner);
        }
    
        // Load contact data
        if (savedData.contact) {
            contactStore.importData(savedData.contact);
        }
    
        // Load terms of use data
        if (savedData.termOfUse) {
            termOfUseStore.importData(savedData.termOfUse);
        }
    } 
    
    return {importDataAllStores};
}